import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { ReturnDisposalDetailState } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import { Col, Form, Input, Row, Spin } from 'antd';
import moment from 'moment';
import Comments from '../../Shared/Attachment/Comment';
import DownloadAttachment from '../../Shared/Attachment/DownloadAttachment';
import CheckPoint from '../../Shared/Common/CheckPoint';
import CurrentImportHistory from '../../Shared/Form/CurrentImportHistory';
import DetailsProductForm from '../../Shared/Form/DetailsProductForm';
import ShipmentMethodForm from '../../Shared/Form/ShipmentMethod';
import ShippingPlantForm from '../../Shared/Form/ShippingPlantForm';
import ProgressForm from '../components/ProgressForm';
import RecipientForm from '../components/RecipientForm';
import returnDisposalService from '@modules/Warehouse/Return/Service/returnDisposal';

interface ReturnImportPageProps {
  canEdit?: boolean;
  doneEdit?: () => void;
  commentId?: number;
}
const ReturnImportPage = ({canEdit, doneEdit, commentId}: ReturnImportPageProps) => {
  const { detailData, detailLoading } =
    useTypedSelector<ReturnDisposalDetailState>(
      (state) => state.returnDisposalDetailReducer
    );

  // products
  const products = detailData?.data?.importProducts?.products;

  // attachment
  const attachments = detailData?.data?.import?.attachments;
  // inventories
  const inventories = products?.map((inventory: any, index: number) => {
    return {
      key: index,
      deliveredDate: inventory
        ? moment(inventory?.inventory?.updatedAt).format(
            'YYYY.MM.DD hh:mm:ss A'
          )
        : '',
      location: inventory ? inventory?.inventory?.location : '',
      estimatedQuantity: inventory
        ? inventory?.inventory?.estimatedQuantity
        : '',
      deliveredQuantity: inventory
        ? inventory?.inventory?.deliveredQuantity
        : '',
      availableQuantity: inventory
        ? inventory?.inventory?.availableQuantity
        : '',
      unavailableQuantity: inventory
        ? inventory?.inventory?.unAvailableQuantity
        : '',
      inspectionResult: inventory ? inventory?.inventory?.inspectionResult : ''
    };
  });

  // shipment method
  const shipmentMethod = detailData?.data?.import;

  const save = async () => {
    if (doneEdit && commentId) {
      await returnDisposalService.updateReturn([], formRecipient.getFieldsValue(), commentId, detailData.data.id);
      doneEdit();
    }
  }

  const [formRecipient] = Form.useForm();

  return (
    <Spin spinning={detailLoading} className="loading-forgot">
      <div
        style={{
          background: 'white',
          padding: '20px',
          margin: '20px',
          marginBottom: 0
        }}
      >
        {detailData?.data?.status && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ display: 'flex' }}>
              <p
                style={{
                  marginBottom: '0px',
                  fontWeight: 'bold',
                  fontSize: '15px'
                }}
              >
                {detailData?.data?.import?.name}
              </p>
              <p
                style={{
                  marginBottom: '0px',
                  marginLeft: '10px',
                  color: '#747274'
                }}
              >
                {detailData?.data?.import?.email}
              </p>
            </div>
            <div
              style={{
                display: 'flex',
                textAlign: 'center',
                alignItems: 'center'
              }}
            >
              <span style={{ marginRight: '10px' }}>Retransfer/Disposal</span>
              <p
                style={{
                  marginBottom: '0',
                  fontWeight: 'bold',
                  fontSize: '15px',
                  width: '150px',
                  borderRadius: '20px',
                  padding: '6px 0px',
                  background: '#2B2C51',
                  color: 'white'
                }}
              >
                {detailData?.data?.status}
              </p>
            </div>
          </div>
        )}
        {
          canEdit &&
          <div>
            <p
              style={{
                marginBottom: '0px',
                fontWeight: 'bold',
                fontSize: '15px',
                width: 'max-content',
                height: '30px',
                marginLeft: 'auto',
                display: 'block',
                padding: '6px 0px',
                color: 'black',
                textAlign: 'center',
                borderBottom: '1px solid black',
                cursor: 'pointer',
                marginTop: '20px'
              }}
              onClick={() => save()}
            >
              Save
            </p>
          </div>
        }
        <DetailsProductForm data={products} edit={false} />
        <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
          <Col className="gutter-row" span={8} style={{ marginLeft: '10px' }}>
            <div className="shipmentMethod">
              <ShipmentMethodForm data={shipmentMethod} edit={false} />
            </div>
          </Col>
          <Col className="gutter-row" span={8}>
            <div className="shippingPlan">
              <ShippingPlantForm data={shipmentMethod} edit={false} />
            </div>
          </Col>
          <Col className="gutter-row" span={7}>
            <div className="checkPoint">
              <CheckPoint data={shipmentMethod} edit={false} />
            </div>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col className="gutter-row" span={8} style={{ marginLeft: '10px' }}>
            <div>
              <DownloadAttachment
                data={attachments}
                label="Customer’s attachments"
                typeButton="Download"
              />
            </div>
          </Col>
          <Col className="gutter-row" span={15}>
            <div>
              <Comments
                title="Comment from Customer"
                message={detailData?.data?.comment}
              />
            </div>
          </Col>
        </Row>
        <div style={{ padding: '10px 30px' }}>
          <CurrentImportHistory inventories={inventories} />
        </div>
        <div style={{ padding: '10px 30px' }} className="orderForm">
          <RecipientForm
            form={formRecipient}
            detailData={detailData?.data}
            edit={canEdit}
            returnQuantities={detailData?.data?.importProducts?.returnQuantity}
          />
        </div>
        {
          !canEdit &&
          <div style={{ padding: '10px 30px' }}>
            <ProgressForm
              detailData={{
                ...detailData?.data,
                deliveryStatus: detailData?.data?.returnStatus
              }}
            />
          </div>
        }
      </div>
    </Spin>
  );
}

export default ReturnImportPage;
